import { Alert, AlertProps } from "antd"

export default function OSAlert(props: AlertProps) {
  const { className = "", type, ...rest } = props
  const isError = type === "error"
  return (
    <Alert
      {...rest}
      type={type}
      showIcon={props.showIcon ?? isError}
      className={`${className} text-13 rounded-lg ${
        isError
          ? "bg-red-50 border border-red-200 [&_.ant-alert-message]:text-red-700 [&_.ant-alert-icon]:text-red-500"
          : ""
      }`}
    />
  )
}
